import * as z from 'zod';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { Doc } from '../../convex/_generated/dataModel';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const phoneSchema = z
  .string()
  .min(1, 'Phone is required') // Ensure the field is not empty
  .regex(/^\(\d{3}\) \d{3} - \d{4}$/, 'Phone number is required')
  .transform((value) => {
    // Allow empty values for backspace
    const digits = value.replace(/\D/g, '');
    if (digits.length === 0) return ''; // Return empty if the user deletes everything
    if (digits.length !== 10) return value; // Skip formatting if not exactly 10 digits
    // Format into (123) 456 - 7890
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)} - ${digits.slice(6)}`;
  });

export const generateDynamicServiceJsonLd = (service: Doc<'services'>) => {
  const cdnUrl = process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_DOMAIN;
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: service.name,
    category: 'Bookbinding and Related Work',
    description: service.shortDescription,
    provider: {
      '@type': 'Organization',
      name: 'RM Bindery LLC',
      url: 'https://www.rmbindery.com',
      logo: `${cdnUrl}/general/rm-color-logo.png`,
    },
    areaServed: 'US',
  };

  return jsonLd;
};
